import { io } from 'socket.io-client';
import {  REACT_APP_NODE_API_BASE_URL } from "./environment";

const socketBaseUrl = REACT_APP_NODE_API_BASE_URL.replace(/\/api\/?$/, '');

const socket = io(socketBaseUrl, {
  autoConnect: false,
  transports: ['websocket'],
});

export default socket;
